import { Component } from '@angular/core';

@Component({
    selector: 'minorView',
    templateUrl: 'minor-view.template.html'
})
export class minorViewComponent { }


// WEBPACK FOOTER //
// ./src/app/views/minor-view/minor-view.component.ts